export default __webpack_public_path__ + "static/media/HUAWEI.0e546185.svg";